import React from 'react';
import { Box, Typography } from '@mui/material';
import { highlightSegments, parseQuery } from '../utils/textSearch.js';

/**
 * Wraps every search hit in the text with a <mark> (P5-08, Tim D09 §1 "phrase highlighted").
 * Renders plain text when there is no query.
 */
export function Highlight({ text, query, terms }) {
  const t = terms || parseQuery(query);
  if (!t.length || !text) return <>{text}</>;
  return (
    <>
      {highlightSegments(String(text), t).map((seg, i) =>
        seg.hit ? (
          <Box
            key={i}
            component="mark"
            sx={{ bgcolor: 'warning.light', color: 'inherit', px: 0.25, borderRadius: 0.5, fontWeight: 600 }}
          >
            {seg.text}
          </Box>
        ) : (
          <React.Fragment key={i}>{seg.text}</React.Fragment>
        )
      )}
    </>
  );
}

/** "…before **match** after…" lines under a search result. */
export function SnippetList({ snippets, sx }) {
  if (!snippets || !snippets.length) return null;
  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.5, ...sx }}>
      {snippets.map((s, i) => (
        <Typography key={i} variant="caption" color="text.secondary" sx={{ lineHeight: 1.5 }}>
          {s.before}
          <Box component="mark" sx={{ bgcolor: 'warning.light', color: 'inherit', px: 0.25, borderRadius: 0.5, fontWeight: 700 }}>
            {s.match}
          </Box>
          {s.after}
        </Typography>
      ))}
    </Box>
  );
}

export default Highlight;
